import { InjectionToken } from '@angular/core';

export const BASE_PATH = new InjectionToken<string>('shieldBasePath');
export const SHIELD_LOGS_PATH = new InjectionToken<string>('shieldLogsPath');
export const COLLECTION_FORMATS = {
  csv: ',',
  tsv: '   ',
  ssv: ' ',
  pipes: '|',
};
